(function () {
    'use strict';

    angular
        .module('app')
        .factory('HttpErrorInterceptorService', HttpErrorInterceptorService);

    HttpErrorInterceptorService.$inject = ['$q', '$rootScope',];

    function HttpErrorInterceptorService($q, $rootScope) {
        var service = {
            responseError: responseError,
        };

        return service;

        // This function catches all promise based requests towards the backend and works as a fail callback.
        function responseError(response) {
            $rootScope.$emit('api-error', response);

            return $q.reject(response);
        }
    }

})();